import axios from 'src/api/Api';
import { put } from 'redux-saga/effects';
import {
    GET_OVERRIDES_LIST_SUCCESS,
    GET_OVERRIDES_LIST_FAILURE,
} from '../actions';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* getOverridesListData(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const url = `/occ/v2/${baseSiteId}/priceOverride/overridelist`;

    const {
        account = '',
        approverName = '',
        isMyOverrides = false,
        myCaseRef = '',
        orderDate = '',
        orderTypeFilter = '',
        pageLimit = 25,
        pageNum = 0,
        requestDateEnd = '',
        requestDateStart = '',
        orderDateEnd = '',
        orderDateStart = '',
        requestorName = '',
        searchTerm = '',
        searchType = '',
        sortOrder = 'ASC',
        sortParam = 'urgency',
        statusTypeFilter = '',
    } = action.payload || {};

    const params = {
        account,
        approverName,
        isMyOverrides,
        myCaseRef,
        orderDate,
        orderTypeFilter,
        pageLimit,
        pageNum,
        requestDateEnd,
        requestDateStart,
        orderDateEnd,
        orderDateStart,
        requestorName,
        searchTerm,
        searchType,
        sortOrder,
        sortParam,
        statusTypeFilter,
    };

    try {
        const response = yield axios
            .get(url, { params })
            .then((res) => res.data);

        yield put({ type: GET_OVERRIDES_LIST_SUCCESS, data: response, statusTypeFilter, orderTypeFilter, isMyOverrides, filterOnly: action.payload?.filterOnly || false, badgeOnly: action.payload?.badgeOnly || false });
    } catch (error) {
        yield put({
            type: GET_OVERRIDES_LIST_FAILURE,
            data: { statusCode: error?.response?.status, statusMessage: error?.message },
        });
        errorHandler(error);
        logUiErrorToBackend({
            errorMessage: `Overrides List API failed: ${error?.message}`,
            errorStack: error?.stack,
        });
    }
}
